// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.91.0-beta.8cb411522',
  revision: '8cb411522',
  branch: 'develop',
  date: 'Thu, 27 Aug 2026 10:26:16 GMT'
};